import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleActivityCategory = {
  namespaced: true,

  state: {
    name: 'activity-category',
    nextSeqCode: null,
    activityCategories: []
  },

  mutations,
  getters,
  actions
}

export default moduleActivityCategory;